import { CheckboxProps, Checkbox, Button, Text } from '@mantine/core';
import classes from './CheckListCheckBox.module.css';
import { MyIcon } from '@web/common-ui';

interface CheckListCheckBoxProps {
  done: boolean;
  deactivated?: boolean;
  index?: number;
  onClick?: () => void;
}

export const CheckListCheckBox = ({
  done,
  deactivated = false,
  index,
  onClick,
}: CheckListCheckBoxProps) => {
  const CheckboxIcon: CheckboxProps['icon'] = ({ ...others }) => (
    <MyIcon
      name="check"
      {...others}
      style={{ height: 22, width: 22, fill: '#fff' }}
    />
  );

  const commonProps = {
    disabled: deactivated,
    color: '#3D7F53',
  };

  const checkboxProps = {
    ...commonProps,
    styles: { label: { fontSize: 16 } },
    size: 'md',
    icon: CheckboxIcon,
    checked: done,
    onChange: onClick,
  };

  const stepperProps = {
    ...commonProps,
    bg: deactivated ? '' : done ? '#3D7F53' : '#fff',
    variant: done ? 'filled' : 'outline',
    radius: 'xl',
    onClick,
  };

  return index === undefined ? (
    <Checkbox {...checkboxProps} />
  ) : (
    <Button {...stepperProps} className={classes.stepperButton}>
      {done ? (
        <MyIcon
          name="check"
          style={{
            height: 22,
            width: 22,
            fill: deactivated ? '#7F898F' : '#fff',
          }}
        />
      ) : (
        <Text
          c={deactivated ? '#7F898F' : '#3D7F53'}
          className={classes.stepIndex}
        >
          {(index ?? 0) + 1}
        </Text>
      )}
    </Button>
  );
};
